import React, {useState} from "react";
import {Box, Button, Drawer, IconButton, Stack} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import {menuItems} from "../../routing/MenuItems";
import {Link as RouterLink} from "react-router";
import {useThemeMode} from "../../styling/ThemeContext";

const MobileMenu = () => {
    const {isDark} = useThemeMode();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <Box>
            <IconButton
                onClick={() => setMobileMenuOpen(true)}
                sx={{
                    color: 'text.secondary',
                    backgroundColor: isDark ? 'primary.dark' : 'primary.main',
                    '&:hover': {
                        backgroundColor: isDark ? 'primary.main' : 'primary.light',
                    },
                    marginBottom: "8px"
                }}
            >
                <MenuIcon sx={{color: isDark ? 'common.white' : 'common.black'}}/>
            </IconButton>

            <Drawer
                anchor="right"
                open={mobileMenuOpen}
                onClose={() => setMobileMenuOpen(false)}
            >
                <Box sx={{p: 2}}>
                    <IconButton
                        onClick={() => setMobileMenuOpen(false)}
                    >
                        <CloseIcon/>
                    </IconButton>
                    <Box sx={{height: '20px'}}/>
                    <Stack spacing={2}>
                        {menuItems.map((item) => (
                            <Button
                                key={item.label}
                                component={RouterLink}
                                to={item.path}
                                onClick={() => setMobileMenuOpen(false)}
                                sx={{width: '100%'}}
                            >
                                {item.label}
                            </Button>
                        ))}
                    </Stack>
                </Box>
            </Drawer>
        </Box>
    );
};
export default MobileMenu